import { render, staticRenderFns } from "./senhas-painel-admin.vue?vue&type=template&id=1b61d91d&"
import script from "./senhas-painel-admin.vue?vue&type=script&lang=js&"
export * from "./senhas-painel-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports